import React from "react";
import { useQuery } from "@tanstack/react-query";
import { api, filterParams, filterKey } from "@/lib/api";
import { fmtCost } from "@/lib/format";
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart,
} from "recharts";

function CustomTooltip({ active, payload, label }) {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-black border border-border p-3 font-mono text-xs">
      <p className="text-white mb-1">{label}</p>
      <p className="text-white">{fmtCost(payload[0].value)}</p>
    </div>
  );
}

export default function CostChart({ filters }) {
  const { data = [] } = useQuery({
    queryKey: ["cost-series", ...filterKey(filters)],
    queryFn: async () => (await api.get("/cost-series", { params: filterParams(filters) })).data,
    refetchInterval: 20000,
  });

  return (
    <div className="bg-card border border-border p-5" data-testid="cost-chart">
      <div className="flex items-center justify-between mb-4">
        <div>
          <p className="overline">cost estimate over time</p>
          <h3 className="text-sm font-medium mt-1">Telemetry-derived (USD)</h3>
        </div>
        <span className="font-mono text-[11px] text-muted-foreground border border-border px-2 py-0.5">from claude_code.cost.usage</span>
      </div>
      <div className="h-[260px]">
        {data.length === 0 ? (
          <div className="h-full flex items-center justify-center font-mono text-xs text-muted-foreground">no data in range</div>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={data} margin={{ top: 8, right: 8, left: -4, bottom: 0 }}>
              <defs>
                <linearGradient id="costFill" x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor="#ffffff" stopOpacity={0.18} />
                  <stop offset="100%" stopColor="#ffffff" stopOpacity={0} />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="0" stroke="#1c1c22" vertical={false} />
              <XAxis dataKey="bucket" stroke="#52525b" tick={{ fontSize: 10, fontFamily: "JetBrains Mono" }} tickFormatter={(v) => v.slice(5)} />
              <YAxis stroke="#52525b" tick={{ fontSize: 10, fontFamily: "JetBrains Mono" }} tickFormatter={(v) => "$" + v.toFixed(2)} />
              <Tooltip content={<CustomTooltip />} />
              <Area type="monotone" dataKey="cost" stroke="#ffffff" strokeWidth={1.5} fill="url(#costFill)" dot={false} activeDot={{ r: 3, fill: "#fff" }} />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}
